import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { i18n } from '@/plugin/vue-i18n';
import { Copy01Icon, Edit01Icon, Trash01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIActionDropdown, renderIcon } from '@gohighlevel/ghl-ui';
import { CHAT_WIDGET_IDS, EMIT_EVENTS, TABLE_ACTION_KEYS, } from './../../helper/const';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ListActions',
    emits: [EMIT_EVENTS.SELECT],
    setup(__props, { emit }) {
        const tableActions = [
            {
                label: i18n.global.t('common.edit'),
                key: TABLE_ACTION_KEYS.EDIT,
                icon: renderIcon(Edit01Icon),
            },
            {
                label: i18n.global.t('common.clone'),
                key: TABLE_ACTION_KEYS.CLONE,
                icon: renderIcon(Copy01Icon),
            },
            {
                label: i18n.global.t('common.delete'),
                key: TABLE_ACTION_KEYS.DELETE,
                icon: renderIcon(Trash01Icon),
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIActionDropdown), {
                id: _unref(CHAT_WIDGET_IDS).LIST_ACTION_DROPDOWN,
                options: tableActions,
                onSelect: _cache[0] || (_cache[0] = (val) => emit(_unref(EMIT_EVENTS).SELECT, val))
            }, null, 8 /* PROPS */, ["id"]));
        };
    }
});
